import { client } from "../client";
import type { Center } from "../types/center.types";
import type { Enterprise } from "../types/enterprises.types";

export const createEnterprise = async ({ ...props }: Enterprise) => {
	const response = await client.post<Enterprise>(`enterprises/`, {
		...props,
		code: props.sageId,
	});
	return response.data;
};

export const updateEnterprise = async ({
	id,
	...props
}: Partial<Enterprise>) => {
	if (!id) {
		return null;
	}
	const response = await client.patch<Enterprise>(`enterprises/${id}`, props);
	return response.data;
};

export const linkCentersToEnterprise = async ({
	enterprise,
	centers,
}: {
	enterprise: Partial<Enterprise>;
	centers: Pick<Center, "id">[];
}) => {
	const response = await client.post<void>(
		`/enterprises/${enterprise.id}/link`,
		{
			centers,
		},
	);
	return response.data;
};

export const enterpriseToggleSleepMode = async ({
	id,
	sleep,
	reason,
}: {
	id: number | string | undefined;
	sleep: boolean;
	reason: string;
}) => {
	const response = await client.patch<void>(`/enterprises/${id}/`, {
		sleep,
		sleepModeReason: reason,
	});
	return response.data;
};

export const archiveEnterpriseToggle = async ({
	id,
	isArchived,
}: {
	id: number | string | undefined;
	isArchived: boolean;
}) => {
	const response = await client.patch<void>(`/enterprises/${id}/`, {
		isArchived,
	});
	return response.data;
};

export const deleteEnterprise = async ({ id }: Partial<Enterprise>) => {
	if (!id) {
		return null;
	}
	const response = await client.delete<Enterprise>(`enterprises/${id}`);
	return response.data;
};
